var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.833V18.333",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 8.33301V9.99967C15.8334 11.5468 15.2188 13.0305 14.1249 14.1245C13.0309 15.2184 11.5472 15.833 10.0001 15.833C8.45299 15.833 6.96925 15.2184 5.87529 14.1245C4.78133 13.0305 4.16675 11.5468 4.16675 9.99967V8.33301",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.16699C12.5 2.78628 11.3807 1.66699 10 1.66699C8.61929 1.66699 7.5 2.78628 7.5 4.16699V10.0003C7.5 11.381 8.61929 12.5003 10 12.5003C11.3807 12.5003 12.5 11.381 12.5 10.0003V4.16699Z",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOn);
export default __webpack_public_path__ + "static/media/mic_on.55a80e24c98136528a15248e73b775fa.svg";
export { ForwardRef as ReactComponent };